import React from 'react';
import './style.scss';

const Loader = () => (
    <div className="loader-backdrop">
        <div className="dual-ring" />
    </div>
);

export default Loader;
export { Loader };


// WEBPACK FOOTER //
// ./src/components/loader/index.js